import React from 'react';
import { FiSettings } from 'react-icons/fi';

// Type cast icons for React 18 compatibility
const SettingsIcon = FiSettings as React.FC<React.SVGProps<SVGSVGElement>>;

// Type-safe field names for delivery settings
type DeliverySettingField = 'require_email' | 'require_nda' | 'watermark_pdfs' | 'allow_downloads';

interface DeliverySettingsProps {
  requireEmail: boolean;
  requireNda: boolean;
  watermarkPdfs: boolean;
  allowDownloads: boolean;
  onChange: (field: DeliverySettingField, value: boolean) => void;
  disabled?: boolean;
}

interface ToggleProps {
  label: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({ label, description, checked, onChange, disabled }) => (
  <div className="su-settings-row">
    <div className="su-settings-info">
      <div className="su-settings-label">{label}</div>
      <div className="su-settings-desc">{description}</div>
    </div>
    <label className="su-toggle">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="su-toggle-slider" />
    </label>
  </div>
);

const DeliverySettings: React.FC<DeliverySettingsProps> = ({
  requireEmail,
  requireNda,
  watermarkPdfs,
  allowDownloads,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="su-dataroom-section">
      <div className="su-dataroom-section-header">
        <div className="su-dataroom-section-title">
          <SettingsIcon />
          <span>Delivery Settings</span>
        </div>
      </div>
      <div className="su-dataroom-section-body">
        <div className="su-settings-list">
          <Toggle
            label="Require Email"
            description="Visitors must enter email to access"
            checked={requireEmail}
            onChange={(val) => onChange('require_email', val)}
            disabled={disabled}
          />
          <Toggle
            label="Require NDA"
            description="Show NDA agreement before access"
            checked={requireNda}
            onChange={(val) => onChange('require_nda', val)}
            disabled={disabled}
          />
          <Toggle
            label="Watermark PDFs"
            description="Add visitor email to PDF documents"
            checked={watermarkPdfs}
            onChange={(val) => onChange('watermark_pdfs', val)}
            disabled={disabled}
          />
          <Toggle
            label="Allow Downloads"
            description="Let visitors download documents"
            checked={allowDownloads}
            onChange={(val) => onChange('allow_downloads', val)}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default DeliverySettings;
